import { render, staticRenderFns } from "./SalesOrderAddEdit.vue?vue&type=template&id=f0231158&scoped=true"
import script from "./SalesOrderAddEdit.vue?vue&type=script&lang=js"
export * from "./SalesOrderAddEdit.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderAddEdit.vue?vue&type=style&index=0&id=f0231158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0231158",
  null
  
)

export default component.exports